import React, { useState, useRef, useEffect } from 'react';
import './UserMenu.css';

const UserMenu = ({ profile, email, onSignOut, onNavigateProfile, onNavigateSystemAdmin, isSuperuser, onShowRecent }) => {
  const [open, setOpen] = useState(false);
  const [avatarError, setAvatarError] = useState(false);
  const menuRef = useRef(null);

  const displayName = profile?.first_name || profile?.last_name
    ? `${profile.first_name || ''} ${profile.last_name || ''}`.trim()
    : email;

  const avatarLetter = (profile?.first_name?.[0] || profile?.last_name?.[0] || email?.[0] || '?').toUpperCase();

  // Reset avatar error when profile changes
  useEffect(() => {
    setAvatarError(false);
  }, [profile?.avatar_url]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="user-menu" ref={menuRef}>
      <button className="user-menu-trigger" onClick={() => setOpen(!open)}>
        <div className="user-avatar">
          {profile?.avatar_url && !avatarError ? (
            <img 
              src={profile.avatar_url} 
              alt={displayName}
              onError={() => setAvatarError(true)}
            />
          ) : (
            <span>{avatarLetter}</span>
          )}
        </div>
        <span className="user-name">{displayName}</span>
        <i className={`fas fa-chevron-${open ? 'up' : 'down'}`}></i>
      </button>
      {open && (
        <div className="user-menu-dropdown">
          <button className="dropdown-item" onClick={() => { setOpen(false); onShowRecent && onShowRecent(); }}>
            <i className="fas fa-history"></i> Recent
          </button>
          <div className="dropdown-divider"></div>
          <button className="dropdown-item" onClick={() => { setOpen(false); onNavigateProfile(); }}>
            <i className="fas fa-user"></i> User Profile
          </button>
          {isSuperuser && (
            <button className="dropdown-item" onClick={() => { setOpen(false); onNavigateSystemAdmin(); }}>
              <i className="fas fa-cog"></i> System Admin
            </button>
          )}
          <div className="dropdown-divider"></div>
          <button className="dropdown-item" onClick={onSignOut}>
            <i className="fas fa-sign-out-alt"></i> Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;

